import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/mypg/iqs`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/myiqs`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0102002q: `${BASE.path}/osci0102002q`, // List of MyIQSs        !== 나의 IQS  목록 ==!
    osci0102003s: `${BASE.path}/osci0102003s`, // Detail for MyIQSs     !== 나의 IQS 상세 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View a IQS List !== IQS 목록 조회 ==!
    getIQSList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Child List By ComnCode  !== 공통코드 자식 List 조회 ==!
    selectChildListByComnCd: (data: any) => {
        return api.post(`${BASE.api}/code`, {
            ...data,
        });
    },

    // save IQS !== IQS 저장 ==!
    saveIQSInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // View a IQS Detail !== IQS 상세 조회 ==!
    getIQSInfo: (iqsId: any, accessData: any) =>
        api.get(`${BASE.api}/${iqsId}`, {
            params: comnUtils.toGetParams(accessData),
        }),
    // View a IQS Detail !== IQS 상세 조회 ==!
    getIQSInfoByBsopId: (data: any) =>
        api.get(`${BASE.api}/getIqsInfo`, {
            params: data,
        }),
    // Get the accessible IQS ID by bsopId !== bsopId로 접근 가능한 IQS ID 조회 ==!
    getIqsIdByBsopId: (bsopId: any, accessData: any) =>
        api.get(`${BASE.api}/getIqsId`, {
            params: comnUtils.toGetParams({ ...accessData, bsopId: bsopId }),
        }),

    // Regist IQS Comment  !== IQS 댓글 등록 ==!
    registIqsComment: (data: any, accessData: any) => {
        return api.post(
            `${BASE.api}`,
            {
                ...data,
            },
            {
                params: comnUtils.toGetParams(accessData),
            },
        );
    },
};

/**
 * Builds the IQS access information sent from the authenticated browser session.
 * The server gives its authenticated user information higher priority when available.
 * !== 로그인 화면 세션에서 IQS 접근정보를 구성하며 서버 인증정보가 있으면 서버값이 우선한다. ==!
 */
export const getIqsAccessData = (auth: any) => {
    const authList = auth.get("authList") || [];
    return {
        loginUsrId: auth.get("usrId"),
        orgCd: auth.get("orgCd"),
        representativeYn: authList.includes("auth_osci0002") ? "Y" : "N",
        systemAdminYn: authList.includes("auth_osci0003") ? "Y" : "N",
    };
};

const iqsSbjctlTpCdListArr = [
    { label: "Text", value: "T" },
    { label: "ComnCode", value: "C" },
];

export const SF_IQS_SRCH: TFormSchema = {
    id: "form_iqsSrch",
    schema: {
        srchFrstRegstId: { type: "text", label: "L_REGST_NM" },
        srchAppNo: { type: "text", label: "L_APP_NO" } /* Application No !== 신청번호 ==!*/,
        loginUsrId: { type: "text", label: "" },
        frstRgsrDtmRnge: {
            type: "daterange",
            label: "L_RGSR_DT",
            start: { name: "regstSrchStrtDt" },
            end: { name: "regstSrchEndDt" },
            rangeButton: 2,
            // controlSize: 10,
        },
        reffNo: { type: "text", label: "L_REFF_NO" },
        docCdVal: { type: "select", label: "L_DOC_NM" },
        actor: { type: "select", label: "L_ACTR", area: "comnCd", comnCd: "OSC0039", viewType: "value" },
        cmntRegstId: { type: "text", label: "L_CMNT_RGST_ID" },
    },
};

export const SF_IQS_CMNT: TFormSchema = {
    id: "form_iqsCmnt",
    schema: {
        iqsCmntCn: { type: "textarea", required: true },
        cdVldVal: { type: "select" },
    },
};

export const SG_IQS: TGridSchema = {
    id: "grid_iqs",
    options: { edit: false, index: true, height: 300, pagination: "out" },
    head: [
        // { cells: [{ header: "L_REFF_NO", binding: "reffNo", width: "*" }] },
        { cells: [{ header: "L_APP_NO", binding: "appNo", width: 200 }] } /* Application No !== 신청번호 ==!*/,
        // { cells: [{ header: "L_DOC_NM", binding: "docCdValNm", width: 200 }] },
        { cells: [{ header: "L_APP", binding: "appNm", width: "*" }] } /* Application(LPCO form) Name !== 신청서(양식)명 ==!*/,
        { cells: [{ header: "L_READ_YN", binding: "rdngYn", width: 50 }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: 130 }] },
        { cells: [{ header: "L_REGST_NM", binding: "usrNm", width: "*" }] },
    ],
    body: [
        // { cells: [{ binding: "reffNo", type: "text", align: "left" }] },
        { cells: [{ binding: "appNo", type: "text", align: "center" }] },
        // { cells: [{ binding: "docCdValNm", type: "text", align: "left" }] },
        { cells: [{ binding: "appNm", type: "text", align: "left" }] },
        { cells: [{ binding: "rdngYn", type: "text", align: "center" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime", align: "center" }] },
        { cells: [{ binding: "usrNm", type: "text", align: "left" }] },
    ],
};
